import api from "./api-service";
import querystring from "querystring";

const url = "/sequences";

const find = (query) => {
  return api().get(`${url}?${querystring.stringify(query)}`);
};

const save = (obj) => {
  return api().post(url, obj);
};

const findOne = (id) => {
  return api().get(`${url}/${id}`);
};

const deleteItemOrder = (type, pointOrder) => {
  if (!!type) {
    return api().delete(`${url}/item-order/${type.slug}/${pointOrder.id}`);
  }
};

const deleteSubItemOrder = (type, subItemOrder) => {
  if (!!type) {
    return api().delete(`${url}/subitem-order/${type.slug}/${subItemOrder.id}`);
  }
};

export { find, save, findOne, deleteItemOrder, deleteSubItemOrder };
